import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {Helmet} from "react-helmet";

import './OurStory.css';
import { Mobile, Desktop } from '../../utils/styles';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

class OurStory extends Component {
	render() {
		return (
			<div className="our-story">
                <Helmet>
                    <title>Our Story - HelloAva</title>
                    <meta name="description" content="HelloAva makes finding the right skincare routine simple. We do the behind-the-scenes heavy lifting, so you can focus on putting your best face forward." />
                </Helmet>
				<div className="section-1">
					<div className="big-message">We work hard to make it easy</div>
					<div className="small-message">HelloAva makes finding the right skincare regimen easier than ever. We do the behind-the-scenes heavy lifting, so you can focus on putting your best face forward.</div>
				</div>
                <Desktop>
    				<div className="section-2">
    					<img  alt="Our story" className="lazyload" data-src="/images/our-story/image-2.jpg" />
    					<div className="desc">
    						<div className="big-message">The beauty product search is frustrating</div>
    						<div style={{ height: '12px' }}></div>
    						<div className="small-message">Between over-the-top marketing campaigns, confusing product labels hiding toxic ingredients and a lack of industry regulation, it can be impossible to determine which products not only will work, but are actually safe to use</div>
    					</div>
    				</div>
                </Desktop>
                <Mobile>
    				<div className="section-2">
    					<div className="desc">
    						<div className="big-message">The beauty product search is frustrating</div>
    						<div style={{ height: '12px' }}></div>
    						<div className="small-message">Between over-the-top marketing campaigns, confusing product labels hiding toxic ingredients and a lack of industry regulation, it can be impossible to determine which products not only will work, but are actually safe to use</div>
    					</div>
                        <img alt="Our story" className="lazyload" data-src="/images/our-story/image-2.jpg" />
    				</div>
                </Mobile>
				<div className="section-3">
					<div className="title">Sadly, this is how most people shop for skincare today</div>
					<div className="desc">
						<div className="column">
							<div className="title">The guessing game</div>
							<div className="message">With 73% of U.S. consumers unable to properly describe their skin type, it’s obvious why finding the appropriate skincare products appears impossible. People are shopping without even knowing what they need — it’s a trial and error process</div>
						</div>
						<hr />
						<div className="column">
							<div className="title">Referrals from friends</div>
							<div className="message">We get by with a little help from our friends. However, when it comes to skincare, asking your bestie what works isn’t the best tactic. Because every person’s skin is different, odds are what works for them most likely won’t work for you (and vice versa)</div>
						</div>
						<hr />
						<div className="column">
							<div className="title">Dermatologist visits</div>
							<div className="message">Getting an expert opinion is never a bad decision. But it can be a time-consuming, expensive one! That’s why HelloAva brings the experts to you. Say “goodbye” to long waits in the dermatologist’s office lobby and costly bills that accompany every appointment</div>
						</div>
					</div>
				</div>
                <Desktop>
    				<div className="section-5">
    					<div className="desc">
    						<div className="big-message-1">Reasons why you can trust us</div>
    						<div className="big-message-2">We’ve got high vetting standards</div>
    						<div className="small-message">We take product testing seriously and work only with trustworthy brands that care about their customers. Testing is an essential step for us to educate ourselves on products’ active and inactive ingredients, and to understand what products best work with which skin type.</div>
    						<div className="big-message-3">We provide honest and unbiased recommendations</div>
    						<div className="small-message">We promise to be honest and unbiased. That means providing complete transparency with our ingredient research as well as how we find and source our products. We will always explain why we recommended certain products over others</div>
    					</div>
    					<img  alt="HelloAva - Our story" className="lazyload" data-src="/images/our-story/image-4.jpg" />
    				</div>
                </Desktop>
                <Mobile>
                    <div className="section-5">
                        <div className="crop">
                            <img alt="HelloAva - Our story" className="lazyload" data-src="/images/our-story/image-4.jpg" />
                        </div>
                        <div className="desc">
                            <div className="big-message-1">Reasons why you can trust us</div>
                            <div className="big-message-2">We’ve got high vetting standards</div>
                            <div className="small-message">We take product testing seriously and work only with trustworthy brands that care about their customers. Testing is an essential step for us to educate ourselves on products’ active and inactive ingredients, and to understand what products best work with which skin type.</div>
                            <hr />
                            <div className="big-message-3">We provide honest and unbiased recommendations</div>
                            <div className="small-message">We promise to be honest and unbiased. That means providing complete transparency with our ingredient research as well as how we find and source our products. We will always explain why we recommended certain products over others</div>
                        </div>
                    </div>
                </Mobile>
			</div>
		);
	}
}

export default withRouter(OurStory);



// WEBPACK FOOTER //
// ./src/views/ourstory/OurStory.js